import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { BlogHome, UpdateBlogHomeRequest } from "./dtos";

const BLOG_HOME_SERVICE = `${Constants.API_URL}/bedrock/blog_home`;

export class BlogHomeServices {
  @scCatchServiceException()
  static async getBlogHome(playerId?: number): Promise<BlogHome> {
    const { data } = await axios.get<BlogHome>(BLOG_HOME_SERVICE, {
      params: playerId != null ? { playerId } : undefined,
    });
    return data;
  }

  @scCatchServiceException()
  static async updateBlogHome(request: UpdateBlogHomeRequest): Promise<BlogHome> {
    const { data } = await axios.patch<BlogHome>(BLOG_HOME_SERVICE, request);
    return data;
  }
}
